<template>
  <div class="form-wrapper">
    <form  @submit.prevent="submit" :data-vv-scope="scope" ref="form">
      <slot></slot>
      <button ref="submitBtn" type="submit" :class="submitBtnClasses">{{submitBtnComputedText}}</button>
    </form>
    <div class="mask" ref="mask"></div>
    <i class="fa fa-refresh fa-spin fa-3x fa-fw spinner" ref="spinner"></i>
  </div>
</template>

<script>
const ExtForm = {
  props: {
    submitBtnText: {
      type: String
    },
    scope: {
      type: String,
      default: ''
    },
    formData: {
      type: Object,
      default () {
        return {}
      }
    },
    extraData: {
      type: Object,
      default () {
        return {}
      }
    },
    submitProxy: {
      type: Object,
      required: true
    },
    beforeSubmitHandler: {
      type: Function,
      required: false
    },
    loadProxy: {
      type: Object,
      default () {
        return {}
      }
    },
    successMsg: {
      type: String,
      default: 'Успешно'
    },
    errorMsg: {
      type: String,
      default: 'Ошибка'
    },
    notyOptions: {
      type: Object,
      default () {
        return {}
      }
    },
    showNotyfications: {
      type: Boolean,
      default: true
    },
    resetAfterSuccessSubmit: {
      type: Boolean,
      default: true
    },
    submitBtnClasses: {
      type: String,
      default: 'btn btn-success'
    },
    emulateSubmit: {
      type: Boolean,
      default: false
    },
    validator: {
      type: Object,
      default: null
    },
    scrollToError: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      _isSubmitProgress: false,
      _isUpdating: false,
      _isLoadProgress: true,
      _validator: '',
      _initData: {}
    }
  },
  computed: {
    submitBtnComputedText () {
      if (!this.submitBtnText) {
        return this._isUpdating ? 'Обновить' : 'Создать'
      }

      return this.submitBtnText
    }
  },
  methods: {
    toggleFormMask () {
      if (this._isLoadProgress || typeof this._isLoadProgress === 'undefined') {
        this.$refs.mask.style.display = 'block'
        this.$refs.spinner.style.display = 'block'
        this.$refs.form.classList.toggle('masked')
      } else {
        this.$refs.form.classList.toggle('masked')
        this.$refs.mask.style.display = 'none'
        this.$refs.spinner.style.display = 'none'
      }
    },
    /**
     * проверяем, были ли изменены данные формы, если имеются
     * доступные для редактирования поля
     */
    isDataChanged () {
      if (this.$children.length) {
        for (let key in this._initData) {
          if (this._initData[key] !== this.formData[key]) {
            return true
          }
        }

        return false
      }

      return true
    },
    getOffset (elem) {
      const box = elem.getBoundingClientRect()
      const body = document.body
      const docElem = document.documentElement

      const scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop
      const scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft

      const clientTop = docElem.clientTop || body.clientTop || 0
      const clientLeft = docElem.clientLeft || body.clientLeft || 0

      const top = box.top + scrollTop - clientTop
      const left = box.left + scrollLeft - clientLeft

      return { top: Math.round(top), left: Math.round(left) }
    },
    toggleBtnProgressState (btn) {
      if (this._isSubmitProgress) {
        this._isSubmitProgress = false
        btn.innerHTML = this._btnTxtTmp
      } else {
        this._isSubmitProgress = true
        this._btnTxtTmp = btn.innerHTML
        btn.innerHTML += '&nbsp;&nbsp;<i class="fa fa-spinner fa-spin fa-fw"></i><span class="sr-only"></span>'
      }
    },
    saveInitialState () {
      this._initData = Object.assign({}, this.formData)
    },
    submit () {
      if (process.env.NODE_ENV === 'development') {
        console.log('Данные формы: \n')
        for (let key in this.formData) {
          console.log(key + ' = ' + this.formData[key] + '\n')
        }
      }
      const validationResult = this.scope
            ? this._validator.validateAll(this.scope)
            : this._validator.validateAll()

      validationResult.then(result => {
        // есть ли ошибки на стороне клиента, ошибки валидации сущности на бэкенде
        // не запрещают отправку формы
        const hasClientErrors = this._validator.errors.items.some(item => {
          if (this.scope) {
            return item.rule !== 'entity_validation' && item.scope === this.scope
          }
          return item.rule !== 'entity_validation'
        })

        if (!hasClientErrors) {
          if (!this._isSubmitProgress && !this._isLoadProgress && this.isDataChanged()) {
            const url = this.submitProxy.url
            const method = this.submitProxy.method
            const submitBtn = this.$refs.submitBtn

            this._validator.errors.clear(this.scope || null)

            if (this.emulateSubmit) {
              this.$emit('submitSuccess', {})
            } else {
              let data = Object.assign(this.formData, this.extraData)
              if (this.beforeSubmitHandler) {
                data = this.beforeSubmitHandler(data)
              }
              this.toggleBtnProgressState(submitBtn)
              this.$http[method](url, data, { headers: { Authorization: this.$store.state.auth.user.token } })
              .then(result => {
                if (this._isUpdating || !this.resetAfterSuccessSubmit) {
                  this.saveInitialState()
                }
                this.$emit('submitSuccess', result.data)
                this.$root.$emit('submitSuccess', result.data, this)
                this.toggleBtnProgressState(submitBtn)
              }, error => {
                this.$emit('submitFailed', error.data)
                this.toggleBtnProgressState(submitBtn)
              })
            }
          }
        } else {
          // скролим к первому не валидному полю
          if (this.scrollToError) {
            const invalidElem = this.$el.querySelector('div.is-invalid')
            document.body.scrollTop = this.getOffset(invalidElem).top + -100
          }
        }
      })
    },
    resetForm () {
      this.$el.querySelectorAll('input').forEach(input => {
        input.value = ''
      })
      for (let key in this.formData) {
        this.formData[key] = ''
      }
    },
    markAsInvalid (data) {
      for (let field in data) {
        this._validator.errors.add(field, data[field], 'entity_validation', this.scope || null)
      }
    }
  },
  created () {
    if (this.loadProxy.url && this.loadProxy.method) {
      // помечаем, что форма используется для редактирование существующей записи
      this._isUpdating = true
    }
  },
  mounted () {
    Object.assign(this.$noty.options, this.notyOptions)

    this._validator = this.validator
      ? this.validator
      : this.$parent.$validator

    if (this._isUpdating) {
      this.toggleFormMask()
      const url = this.loadProxy.url
      const method = this.loadProxy.method
      this.$http[method](url, {}, { headers: { Authorization: this.$store.state.auth.user.token } })
      .then(result => {
        this.$emit('loadSuccess', result.data)
      }, error => {
        this.$emit('loadFailed', error.data)
      })
    } else {
      this._isLoadProgress = false
      // клонируем начальные данные формы для отслеживания изменений
      this.saveInitialState()
    }

    this.$on('submitSuccess', data => {
      const msg = data.message || this.successMsg

      if (this.showNotyfications) {
        this.$noty.success(msg)
      }
      // форма не сбрасывается только в случае редактирования существующей
      // сущности или если выставлен соответствующий параметр
      if (!this._isUpdating && this.resetAfterSuccessSubmit) {
        this.resetForm()
      }
      this._validator.clean(this.scope || null)
    })

    this.$on('submitFailed', data => {
      if (this.showNotyfications) {
        this.$noty.error(data.message || this.errorMsg)
      }
      this.markAsInvalid(data.errors)
    })

    this.$on('loadSuccess', data => {
      for (let key in data) {
        if (key in this.formData && data[key] !== null) {
          this.formData[key] = data[key]
        }
      }
      this.saveInitialState()
      this._isLoadProgress = false
      this.toggleFormMask()
    })

    this.$on('loadFailed', data => {
      this._isLoadProgress = false
      this.toggleFormMask()
    })
  }
}

export default ExtForm
</script>

<style scoped>
  .form-wrapper {
    position: relative;
  }
  .masked {
    filter: blur(5px);
  }

  .spinner {
    color: #737575;
    margin-left: -20px;
    margin-top: -24px;
    position: absolute;
    left: 50%;
    top: 50%;
    display: none;
  }

  .mask {
    position: absolute;
    z-index: 9999;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: none;
  }

</style>



// WEBPACK FOOTER //
// ExtForm.vue?0187cbbd